import script from "./PaymentMethodMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodMobile.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodMobile.vue?vue&type=style&index=0&id=da691a84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da691a84"]])

export default __exports__